<template>
  <el-backtop class="back-top mt-10"  :bottom="60">
    <div class="back-top-item">
      <el-icon><CaretTop /></el-icon>
    </div>
  </el-backtop>
  <el-backtop class="back-top" :visibility-height="0"  :bottom="100">
<el-popover
    placement="left"
    :width="100"
    trigger="hover"
    @show="onPopoverShow"
  >
     <div class="text-center fw-600 text-primary">分享当前页面</div>
      <div class="flex-one">
        <QRCode ref="qRCodeRef" />
      </div>
    <template #reference>
    <div class="back-top-item" @click.stop="()=>{}" title="分享"><el-icon><Share /></el-icon></div>
    </template>
  </el-popover>
  </el-backtop>
</template>

<script>
import { reactive,ref } from 'vue'
import { CaretTop,Share } from '@element-plus/icons-vue'
import QRCode from '@/components/qr-code'

export default {
  components:{
    CaretTop,
    Share,
    QRCode
  },
  setup() {
    const data = {
      visible: false
    }
    const qRCodeRef = ref(null)
    const offset = 300
    window.onscroll = () => {
      const { scrollY } = window
      data.visible = scrollY > offset
    }

    const onPopoverShow = ()=>{
      qRCodeRef.value && qRCodeRef.value.generateCode(window.location.href)
    }
    return {
      ...reactive(data),
      qRCodeRef,
      onPopoverShow
    }
  }
}
</script>

<style lang="scss" scoped>
.back-top {
  display: flex;
  flex-direction: column;
  background-color: transparent;
  box-shadow: none;
  height: 35px;
  width: 35px;
  &-item {
    height: 100%;
    width: 100%;
    background-color: var(--el-bg-color-overlay);
    box-shadow: var(--el-box-shadow-lighter);
    text-align: center;
    color: #1989fa;
    font-size: 1.125rem;
    padding: 0.375rem;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
</style>

<style>
.el-popover.el-popper {
  min-width: 100px !important;
  text-align: center;
}
</style>
